import _toConsumableArray from "/Users/ahmerafzal/Documents/Work/Brandripplr/v2/project/brandripplr/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "flex flex-column gap-1"
};
var _hoisted_2 = {
  key: 0,
  class: "text-sm text-color-secondary"
};
var _hoisted_3 = {
  key: 0
};
var _hoisted_4 = {
  key: 0,
  class: "w-full flex align-items-center flex-column p-5"
};
var _hoisted_5 = {
  key: 1,
  class: "w-full flex align-items-center flex-column p-5 text-color-secondary"
};
var _hoisted_6 = {
  key: 2
};
var _hoisted_7 = {
  key: 0,
  class: "mb-3"
};
var _hoisted_8 = {
  class: "protocols-view-layout border-1 surface-border border-round"
};
var _hoisted_9 = {
  class: "protocols-view-nav"
};
var _hoisted_10 = ["onClick"];
var _hoisted_11 = {
  class: "protocols-view-label"
};
var _hoisted_12 = {
  class: "protocols-view-content"
};
var _hoisted_13 = {
  class: "text-base font-semibold mb-3"
};
var _hoisted_14 = ["innerHTML"];
var _hoisted_15 = {
  key: 1,
  class: "text-sm text-color-secondary font-italic"
};
var _hoisted_16 = {
  class: "flex justify-content-end border-top-1 surface-border pt-4"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ProgressSpinner = _resolveComponent("ProgressSpinner");
  var _component_SelectButton = _resolveComponent("SelectButton");
  var _component_Button = _resolveComponent("Button");
  var _component_Dialog = _resolveComponent("Dialog");
  return _openBlock(), _createBlock(_component_Dialog, {
    visible: $data.clientProtocolsViewDialog.showDialog,
    "onUpdate:visible": _cache[2] || (_cache[2] = function ($event) {
      return $data.clientProtocolsViewDialog.showDialog = $event;
    }),
    appendTo: "body",
    modal: "",
    breakpoints: {
      '960px': '75vw',
      '640px': '100vw'
    },
    style: {
      width: '65vw'
    },
    draggable: false,
    resizable: false
  }, {
    header: _withCtx(function () {
      var _$data$brand$company;
      return [_createElementVNode("div", _hoisted_1, [_cache[4] || (_cache[4] = _createElementVNode("h1", {
        class: "m-0 text-900 font-semibold text-xl line-height-3"
      }, "Client Protocols", -1)), $data.brand ? (_openBlock(), _createElementBlock("span", _hoisted_2, [_createTextVNode(_toDisplayString($data.brand.brand_name) + " ", 1), $data.activeSource === $data.protocolScope.COMPANY && (_$data$brand$company = $data.brand.company) !== null && _$data$brand$company !== void 0 && _$data$brand$company.company_name ? (_openBlock(), _createElementBlock("span", _hoisted_3, [_cache[3] || (_cache[3] = _createTextVNode(" · shared from ", -1)), _createElementVNode("b", null, _toDisplayString($data.brand.company.company_name), 1)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])];
    }),
    footer: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_16, [_createVNode(_component_Button, {
        label: "Close",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return $data.closeClientProtocolsViewDialog();
        }),
        class: "p-button-text"
      })])];
    }),
    default: _withCtx(function () {
      return [$data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_ProgressSpinner, {
        strokeWidth: "3",
        style: {
          "width": "40px",
          "height": "40px"
        }
      }), _cache[5] || (_cache[5] = _createElementVNode("span", {
        class: "mt-2 text-sm"
      }, "Loading protocols...", -1))])) : !$data.brand ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toConsumableArray(_cache[6] || (_cache[6] = [_createElementVNode("i", {
        class: "pi pi-briefcase mb-2",
        style: {
          "font-size": "1.75rem"
        }
      }, null, -1), _createElementVNode("span", {
        class: "text-sm"
      }, "Select a brand to view its client protocols.", -1)])))) : (_openBlock(), _createElementBlock("div", _hoisted_6, [$options.sources.length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_SelectButton, {
        modelValue: $data.activeSource,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return $data.activeSource = $event;
        }),
        options: $options.sources,
        optionLabel: "label",
        optionValue: "key",
        allowEmpty: false
      }, null, 8, ["modelValue", "options"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.protocolSections, function (section) {
        return _openBlock(), _createElementBlock("button", {
          type: "button",
          key: section.key,
          class: _normalizeClass(["protocols-view-item", {
            'is-active': $data.activeProtocolKey === section.key
          }]),
          onClick: function onClick($event) {
            return $data.activeProtocolKey = section.key;
          }
        }, [_createElementVNode("span", {
          class: _normalizeClass(["protocols-view-dot", {
            'is-filled': $options.hasProtocolContent(section.key)
          }])
        }, null, 2), _createElementVNode("span", _hoisted_11, _toDisplayString(section.label), 1)], 10, _hoisted_10);
      }), 128))]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, _toDisplayString($options.activeProtocolLabel), 1), $options.hasProtocolContent($data.activeProtocolKey) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "protocols-view-html ql-editor",
        innerHTML: $options.currentProtocols[$data.activeProtocolKey]
      }, null, 8, _hoisted_14)) : (_openBlock(), _createElementBlock("div", _hoisted_15, " No protocol has been added for this stage yet. "))])])]))];
    }),
    _: 1
  }, 8, ["visible"]);
}